export class ShopName {
    constructor(public tparName: string, public googleName: string) { }
}
